import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=46b12564&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&id=46b12564&lang=less&scoped=true&"
import style1 from "./layout.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b12564",
  null
  
)

export default component.exports